/* eslint-disable import/prefer-default-export */
export function initFacebookSDK() {
  window.fbAsyncInit = function () {
    // eslint-disable-next-line no-undef
    FB.init({
      appId: process.env.VUE_APP_PROJECT_FACEBOOK_APP_ID,
      cookie: true,
      xfbml: true,
      version: 'v6.0',
    });
  };

  (function (d, s, id) {
    const fjs = d.getElementsByTagName(s)[0];

    if (d.getElementById(id)) { return; }
    const js = d.createElement(s); js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
}

export function saveSession(token) {
  localStorage.setItem('arcux_auth_token', token);
}

export function clearSession(mode = 1) {
  localStorage.removeItem('arcux_auth_token');
  localStorage.removeItem('arcux_auth');

  if (mode === 2) window.location.href = '/salir';
}
